import SelectedArticle from './SelectedArticle';

export default SelectedArticle;
